<template>
  <div class="chart-card">
    <h3 class="chart-title">Completion Trends</h3>
    <div class="chart-container">
      <canvas id="trendsChart"></canvas>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["completed","in_progress","labels"],
    mounted() {
      const instance = this;
      var scriptTag = document.createElement("script");
      scriptTag.src = "https://cdnjs.cloudflare.com/ajax/libs/Chart.js/3.9.1/chart.min.js";
      scriptTag.id = "chart";
      document.getElementsByTagName('head')[0].appendChild(scriptTag);
      scriptTag.onload = function () {
        const trendsCtx = document.getElementById('trendsChart').getContext('2d');
        const trendsChart = new Chart(trendsCtx, {
          type: 'line',
          data: {
            // labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
            labels: instance.labels,
            datasets: [{
              label: 'Completed',
              data: instance.completed,
              borderColor: '#10b981',
              backgroundColor: 'rgba(16, 185, 129, 0.1)',
              tension: 0.4,
              fill: true
            },
            {
              label: 'In Progress',
              data: instance.in_progress,
              borderColor: '#f59e0b',
              backgroundColor: 'rgba(245, 158, 11, 0.1)',
              tension: 0.4,
              fill: true
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: 'bottom'
              }
            },
            scales: {
              y: {
                beginAtZero: true
              }
            }
          }
        });
      }

    }
  };
</script>

<style scoped>
  .chart-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  }

  .chart-title {
    font-size: 18px;
    margin-bottom: 20px;
    font-weight: 700;
  }

  .chart-container {
    position: relative;
    height: 300px;
  }
</style>
